export default __webpack_public_path__ + "static/sizzle_mobile-5162cbe4d0cf9552054cfe53910a698c.mp4";